import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link, NavLink, withRouter } from 'react-router-dom';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import {
  Popper,
  ClickAwayListener,
  MenuList,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel
} from '@material-ui/core';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import { isMobile, isMobileOnly, isTablet } from 'react-device-detect';
import ResizeObserver from 'resize-observer-polyfill';

import './Navbar.scss';
import AppContext from '../../../App.context';
import AppModeContext from 'src/containers/AppMode/AppMode.context';
import logo from '../../../assets/images/betxchange-logo.png';
import Icon from '../../Icon/Icon';
import BurgerMenu from '../BurgerMenu/BurgerMenu';
import Button from '../../Button/Button';
import UserDrawer from '../UserDrawer/UserDrawer';

class Navbar extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      userOpen: false,
      scrolled: 0,
      width: window.innerWidth,
      selectedTheme: 'dark'
    };

    this.menuRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.listenToScroll);
    window.addEventListener('resize', this.componentResized);

    this.listenToScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll);
    window.removeEventListener('resize', this.componentResized);

    if (this.navbar) {
      this.resizeObs.unobserve(this.navbar);
    }
  }

  addRef = (el) => {
    this.navbar = el;

    if (this.navbar) {
      this.resizeObs = new ResizeObserver(this.componentResized);
      this.resizeObs.observe(this.navbar);
    }
  }

  componentResized = () => {
    this.setState({
      width: window.innerWidth
    });
  }

  listenToScroll = () => {
    const scrolled = document.body.scrollTop || document.documentElement.scrollTop;

    this.setState({ scrolled });
  }

  closeMenu = () => {
    this.setState({ userOpen: false });
  }

  toggleMenu = () => {
    this.setState({
      userOpen: !this.state.userOpen
    });
  }

  toggleNavbarMenu = (item, status, clicked = false) => () => {
    if (item.subMenu) {
      this.setState({ [`${ item.title }Open`]: status });
    }

    if (clicked) {
      this.props.resetSearchResults();
    }
  }

  handleWalletChange = (e) => {
    this.props.selectWallet(e.target.value);
  }

  handleClickMenu = currentLink =>  {
    if (currentLink === window.location.pathname) {
      this.props.history.go(0);
    }

    this.props.resetSearchResults();
  }

  handleSettings = (e) => {
    this.props.updateSettings({
      [e.target.name]: e.target.checked
    });
  }

  checkPagedown = () => {
    const { history, history:{ location : { pathname } } } = this.props;
    if (pathname.includes('/register')){
      history.push('/lotto');
    } else if (pathname.includes('/lotto')){
      history.push('/sports-betting');
    } else if (pathname.includes('/sports')){
      history.push('/racing');
    } else if (pathname === '/') {
      history.push('/register-bet');
    } else {
      history.push('/');
    }
  }

  checkPageup = () => {
    const { history, history:{ location : { pathname } } } = this.props;
    if (pathname.includes('/register')){
      history.push('/');
    } else if (pathname.includes('/lotto')){
      history.push('/register-bet');
    } else if (pathname.includes('/sports')){
      history.push('/lotto');
    } else if (pathname.includes('racing')){
      history.push('/sports-betting');
    } else if (pathname === '/'){
      history.push('/racing');
    } else {
      history.push('/');
    }
  }

  onKeyEvent = (key, e) => {
    const { tillLogout, menu, retailHome } = this.props;
    if (key === 'f11' || e.keyCode === 122 || e.key === 'F11'){
      e.preventDefault();
      tillLogout({ showInactivityMessage: false, hardLogout: false, expired:false });
    }

    let elem = _.find(menu, (item) => item.shortcut && item.shortcut.name === e.key);

    if (!elem){
      elem = _.find(retailHome, (item) => item.shortcut && item.shortcut.name === e.key);
    }

    if (elem){
      e.preventDefault();
      this.props.history.push(elem.link);
    }

    if (key === 'pagedown'){
      e.preventDefault();
      this.checkPagedown();
    } else if (key === 'pageup'){
      e.preventDefault();
      this.checkPageup();
    }
  }

  renderLabel = (retailMode, item) => {
    const { t } = this.props;

    if (retailMode) {
      const hasShortCut = item.shortcut;
      return t(`navBar.${ item.title }`, { key: hasShortCut ? item.shortcut.name : '' });
    }
    if (!item.label) return t(`navBar.${ item.title }`);
    return item.label;
  }

  buildMenuStart = (RETAIL_MODE, TRADING_MODE) => {
    const { t, menu, authenticated } = this.props;

    let menuItems = menu;
    if (RETAIL_MODE) {
      menuItems = _.filter(menu, m => m.showInRetail);
    } else if (TRADING_MODE) {
      menuItems = _.filter(menu, m => m.showTrading);
    } else {
      menuItems = _.filter(menu, m => m.showInBetSite !== false);
    }

    return _.map(menuItems, (item, i) => {
      if (item.subMenu && item.subMenu.length > 0) {
        return (
          <div
            key={ i }
            className={
              classNames({
                'navbar__menu-item': true,
                'navbar__menu-item--open': this.state[`${ item.title }Open`]
              })
            }
            onMouseEnter={ this.toggleNavbarMenu(item, true) }
            onMouseLeave={ this.toggleNavbarMenu(item, false) }
          >
            <NavLink
              activeClassName={ item.link && 'navbar__link--active' }
              className="navbar__link"
              to={ item.link ? `${ item.link }` : '#' }
              ref={ el => this[`${ item.title }Anchor`] = el }
              onClick={ () => item.link && this.handleClickMenu(item.link) }
            >
              { this.renderLabel(RETAIL_MODE, item, i) }
            </NavLink>
            <Popper
              className="navbar__sub-menu-container"
              open={ this.state[`${ item.title }Open`] || false }
              anchorEl={ this[`${ item.title }Anchor`] }
              placement="bottom-start"
              transition
              disablePortal
            >
              <ClickAwayListener onClickAway={ this.toggleNavbarMenu(item, false) }>
                <MenuList
                  className="navbar__sub-menu"
                  autoFocusItem={ this.state[`${ item.title }Open`] }
                >
                  {
                    item.subMenu && _.map(item.subMenu, (subItem, j) => {
                      return (
                        <NavLink
                          key={ j }
                          { ...(item.useActiveClass !== false && { activeClassName: 'navbar__link--active' }) }
                          className="navbar__link"
                          to={ `${ subItem.link }` }
                          onClick={ this.toggleNavbarMenu(item, false, true) }
                        >
                          { subItem.label ? subItem.label : t(`navBar.${ subItem.title }`) }
                        </NavLink>
                      );
                    })
                  }
                </MenuList>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      }

      if (_.includes(item.link, 'http')) {
        return (
          <a
            key={ i }
            className="navbar__link"
            href={ item.link }
            target="_blank"
            rel="noopener noreferrer"
          >
            { t(`navBar.${ item.title }`) }
          </a>
        );
      }

      if (item.private) {
        if (!authenticated) return;

        return (
          <NavLink
            key={ i }
            activeClassName="navbar__link--active"
            className="navbar__link"
            to={ `${ item.link }` }
            onClick={ () => this.handleClickMenu(item.link) }
          >
            { t(`navBar.${ item.title }`) }
          </NavLink>
        );
      }

      const hasShortCut = item.shortcut;

      return (
        <NavLink
          key={ i }
          activeClassName="navbar__link--active"
          className="navbar__link"
          exact={ item.link === '/' }
          to={ `${ item.link }` }
          onClick={ () => this.handleClickMenu(item.link) }
        >
          { RETAIL_MODE ? t(`navBar.${ item.title }`, { key: hasShortCut ? item.shortcut.name : '' }) : t(`navBar.${ item.title }`) }
        </NavLink>
      );
    });
  }

  activeWalletsRadioGroup = () => {
    const { customer: { wallets }, activeWallet } = this.props;

    return (
      <RadioGroup
        className="navbar__user-menu__radio"
        aria-label="wallet"
        name="wallet"
        value={ activeWallet && activeWallet.type }
        onChange={ this.handleWalletChange }
      >
        {
          _.map(wallets, (wallet, index) => (
            <MenuItem key={ index } disableGutters="true" className="navbar__user-menu__submenu">
              <FormControlLabel
                className="navbar__user-menu__submenu"
                value={ wallet.type }
                control={
                  <Radio
                    color="primary"
                    checkedIcon={ <Icon icon="radioButton" /> }
                    icon={ <Icon icon="radioButtonOpen" /> }
                  />
                }
                label={
                  <span className="navbar__user-menu__submenu">
                    { `${ _.capitalize(wallet.type) } ${ wallet.currency } ${ (wallet.balance / wallet.divisor).toFixed(2) }` }
                  </span>
                }
              />
            </MenuItem>
          ))
        }
      </RadioGroup>
    );
  }

  navbarUser = () => {
    return (<UserDrawer />);
  }

  navbarLogin = (RETAIL_MODE, TRADING_MODE) => {
    const { t, modalType } = this.props;

    return (
      <>
        {
          !RETAIL_MODE && !TRADING_MODE &&(<>
            <Button
              className="btn--primary navbar__button"
              size="medium"
              onClick={ () => modalType('#login') }
              name="login"
              text= { t('login') }
            />
            <Button
              className="btn--primary navbar__button"
              size="medium"
              onClick={ () => modalType('#register') }
              name="register"
              text={ t('register') }
            />
          </>
          )
        }
        {
          this.props.authenticated && (
            this.navbarUser()
          )
        }
      </>
    );
  }

  handleOnThemeChange = (theme) => {
    this.setState({ isThemeOpen: false, selectedTheme: theme });

    if (theme === 'dark') {
      document.documentElement.classList.add('dark-theme');
    }

    if (theme === 'light') {
      document.documentElement.classList.remove('dark-theme');
    }
  }

  renderThemeDropdown = () => {
    const { t } = this.props;

    return (
      <div
        className={
          classNames({
            'navbar__menu-item': true,
            'navbar__menu-item--open': this.state.isThemeOpen
          })
        }
        onMouseEnter={ () => this.setState({ isThemeOpen: true }) }
        onMouseLeave={ () => this.setState({ isThemeOpen: false }) }
      >
        <NavLink
          className="navbar__link"
          to={ '#' }
          ref={ el => this.themeAnchorEl = el }
        >
          { t('theme.name') }
        </NavLink>
        <Popper
          className="navbar__sub-menu-container"
          open={ this.state.isThemeOpen || false }
          anchorEl={ this.themeAnchorEl }
          placement="bottom-start"
          transition
          disablePortal
        >
          <ClickAwayListener onClickAway={ () => this.setState({ isThemeOpen: false }) }>
            <MenuList
              className="navbar__sub-menu"
              autoFocusItem={ this.state.isThemeOpen }
            >
              <NavLink
                { ...(this.state.selectedTheme === 'dark' && { activeClassName: 'navbar__link--active' }) }
                className="navbar__link"
                to={ '#' }
                onClick={ () => this.handleOnThemeChange('dark') }
              >
                { t('theme.dark') }
              </NavLink>
              <NavLink
                { ...(this.state.selectedTheme === 'light' && { activeClassName: 'navbar__link--active' }) }
                className="navbar__link"
                to={ '#' }
                onClick={ () => this.handleOnThemeChange('light') }
              >
                { t('theme.light') }
              </NavLink>
            </MenuList>
          </ClickAwayListener>
        </Popper>
      </div>
    );

  }

  render() {
    const { authenticated } = this.props;

    return (
      <AppContext.Consumer>
        {
          ({ isPortrait }) => (
            <AppModeContext.Consumer>
              {
                ({ RETAIL_MODE, TRADING_MODE }) => (
                  <nav className={ classNames('navbar', { 'navbar--retail': RETAIL_MODE }) }>
                    {
                      RETAIL_MODE && (
                        <KeyboardEventHandler
                          handleFocusableElements={ true }
                          handleKeys={ ['all'] }
                          onKeyEvent={ this.onKeyEvent }
                        />
                      )
                    }

                    {
                      this.state.width < 1508 && !isMobile && !RETAIL_MODE && !TRADING_MODE &&
                      <div className="navbar__user-options-icons">
                        { <BurgerMenu /> }
                      </div>
                    }
                    {
                      (isMobileOnly || (isTablet && isPortrait)) && !RETAIL_MODE && !TRADING_MODE && (
                        <div className="navbar__user-options-icons">
                          <BurgerMenu />
                          <Link to="/"><img alt="Betxchange.com" src={ logo } className="logo" /></Link>
                        </div>
                      )
                    }
                    <div className="navbar__links" ref={ this.menuRef }>
                      {
                        (this.state.width >= 1508 || (isTablet && !isPortrait) || RETAIL_MODE || TRADING_MODE) && (
                          <>
                            { this.buildMenuStart(RETAIL_MODE, TRADING_MODE) }
                            { this.renderThemeDropdown() }
                          </>
                        )
                      }
                    </div>

                    <div className={
                      classNames({
                        'navbar__user-options': true,
                        'navbar__user-options--two-rows': authenticated && (isMobileOnly || (isTablet && isPortrait)),
                        'navbar__user-options--open': this.state.userOpen
                      })
                    }
                    >
                      {
                        this.props.authenticated && (!RETAIL_MODE && !TRADING_MODE)
                          ? this.navbarUser()
                          : this.navbarLogin(RETAIL_MODE, TRADING_MODE)
                      }
                    </div>
                  </nav>
                )
              }
            </AppModeContext.Consumer>
          )
        }
      </AppContext.Consumer>
    );
  }
}

Navbar.propTypes = {
  logout: PropTypes.func,
  authenticated: PropTypes.bool,
  t: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
  menu: PropTypes.array,
  retailHome: PropTypes.array,
  customer: PropTypes.object,
  updateSettings: PropTypes.func,
  showBalance: PropTypes.bool,
  selectWallet: PropTypes.func,
  activeWallet: PropTypes.object,
  resetSearchResults: PropTypes.func,
  modalType: PropTypes.func,
  tillLogout: PropTypes.func,
  tradingLogout: PropTypes.func
};

const mapState = state => ({
  authenticated: state.auth.authenticated,
  menu: state.content.menu,
  retailHome: state.content.retailHome,
  customer: state.auth.customer,
  showBalance: state.content.settings.showBalance,
  activeWallet: state.auth.activeWallet
});

const mapDispatch = dispatch => ({
  logout: () => dispatch.auth.logout(),
  updateSettings: obj => dispatch.content.updateSettings(obj),
  selectWallet: obj => dispatch.auth.selectWallet(obj),
  modalType: obj => dispatch.content.modalType(obj),
  resetSearchResults: () => dispatch.events.resetSearchResults(),
  tillLogout: obj => dispatch.auth.tillLogout(obj),
  tradingLogout: (value) => dispatch.auth.tradingLogout(value)
});

export default withRouter(connect(mapState, mapDispatch)(withTranslation('common')(Navbar)));
